import { MockService } from '@app/mock/api/mock-service';
import { CalendarService } from '@app/shared/api/interfaces/calendar.service';
import { Calendar } from '@app/domain/one_to_one/model/calendar.model';
import { HttpRequest } from '@angular/common/http';
import { sanitizeUrl } from '@app/shared/utils/helpers';
import { CalendarAccessStatus, CalendarConnectionStatus } from '@app/domain/one_to_one/model/calendar-connected.model';
import { Observable, of } from 'rxjs';
import { SSOProvider } from '@app/models/auth/sso-provider.enum';

export class CalendarMockService implements MockService, CalendarService {
  handleRoute(req: HttpRequest<any>): any {
    const url = sanitizeUrl(req.urlWithParams);
    switch (true) {
      case url.endsWith('api/calendar/availability'):
        return this.getAvailability([''], '', '', '');
      case url.endsWith('api/calendar/connected'):
        return this.isConnected();
      case url.endsWith('api/calendar/connect'):
        return this.connect(req.body?.provider, req.body?.authorizationCode);
      case url.endsWith('api/calendar/disconnect'):
        return this.disconnect();
    }
  }

  getAvailability(emails: string[], startDateTime: string, endDateTime: string, timezone: string): Observable<Calendar[]> {
    return of([]);
  }

  connect(provider: SSOProvider, authorizationCode: string): Observable<CalendarConnectionStatus> {
    return of({ connected: true, provider, access: CalendarAccessStatus.CONNECTED });
  }

  disconnect(): Observable<CalendarConnectionStatus> {
    return of({ connected: false, provider: null, access: CalendarAccessStatus.NOT_LINKED });
  }

  isConnected(): Observable<CalendarConnectionStatus> {
    return of({connected: false, provider: null, access: CalendarAccessStatus.NOT_LINKED});
  }
}
